<template>
    <div>
        <div class="main-h main">
            <div @click="mini" class="icon">
                <i style="font-weight: 20px;" class="mdi mdi-close-box"></i>
            </div>
            <div>
               <span class="refresh" style="color:white">Refresh</span> <i   style="font-weight: 20px;" @click="fetchChat" class="mdi mdi-refresh icon"></i>
            </div>
        </div>
        <div class="wrapper" style="cursor: default;" :style="{height:chat_box + 'px'}">
            <!-- <transition name="slide"> -->
            <div class="chat-box main" v-if="toggle">
                <div :style="{height:chat_div + 'px'}" class="chat-div" ref="messagesContainer">
                    <!-- <div v-if="!proctor_avability" class="center" :style="{paddingTop:pt + 'px'}">
                        <p>No Faculty available for chatting.</p>
                    </div> -->
                    <div v-if="proctor_avability && chatHistory.length == 0" class="first-msg" :style="{paddingTop:pt + 'px'}">
                        <p>Communicate with your Faculty for any type of queries.</p>
                    </div>
                    <div v-for="(msg,index) in chatHistory" :key="index">
                        <div v-if="msg.proctor_msg" class="grid-s">
                            <div id="p-chat-btn">
                                <div>
                                    <div class="sender-name">{{msg.proctor_name}}</div>
                                    <div class="stud-msg-text">{{msg.msg}}</div>
                                    <div class="time">{{msg.timeDate}}</div>
                                </div>
                            </div>
                        </div>

                        <div v-if="!msg.proctor_msg" class="grid-e">
                            <div id="stud-chat-btn">
                                <div>
                                    <!-- <div class="sender-name">{{msg.stud_name}}</div> -->
                                    <div class="stud-msg-text">{{msg.msg}}</div>
                                </div>
                                <div class="time">{{msg.timeDate}}</div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- <div> -->
                <v-row class="msg">
                    <v-text-field v-on:keyup.enter="sendMsg" autocomplete="off" autofocus v-model="msg" placeholder="Type your message"></v-text-field>
                    <i style="font-weight: 20px; font-size: 25px; padding-top: 1rem;" @click="sendMsg({behavior: 'smooth'})" class="mdi mdi-send"></i>
                </v-row>
                <!-- </div> -->
            </div>
            <!-- </transition> -->
        </div>
        <div v-if="!toggle" @click="minimize" class="chat-icon">
            <div>
                <i class="mdi mdi-wechat" style="color: hsla(190, 99%, 30%, 1);"></i>
            </div>
        </div>
        <v-snackbar v-model="snackbar" :color="color" :timeout="6000">
            <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
    </div>
</template>

<script>
    import axios from "axios";
    export default {
        data: () => ({
            chatHistory: [],
            proctor_avability: "",
            arr: ["Hello Sir", "Sneha Mahadik here"],
            msg: "",
            pt: "",
            c_data: null,
            toggle: true,
            dialog: true,
            snackbar_msg: "",
            snackbar: false,
            color: "",
            chat_box: "",
            org: null,
            chat_div: "",
            content: "",
            //
        }),
        watch: {
            toggle() {
                if (this.toggle == true) {
                    this.fetchChat();
                }
            },
        },
        props: ["chat_data"],
        methods: {
            minimize() {
                //   this.content = this.$refs.messagesContainer;
                //  this.content.scrollTop = this.content.scrollHeight
                this.toggle = !this.toggle;
                this.chat_data.flag = true;
                this.msg = "";
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            mini() {
                this.toggle = !this.toggle;
                this.msg = "";
                // this.childrenRequest("true");
            },
            sendMsg() {
                if (this.msg == "") {
                    return;
                }
                this.arr.push(this.msg);
                const data = {
                    les_id: this.chat_data.les_id,
                    msg: this.msg,
                };
                this.msg = "";
                axios
                    .post("/student/sendFromStud", data)
                    .then((res) => {
                        if (res.data.msg == "200") {
                            this.fetchChat();
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong...");
                    })
                    .finally(() => {});
            },
            fetchChat() {
                const data = {
                    id: this.chat_data.les_id,
                };
                axios
                    .post("/student/studChat", data)
                    .then((res) => {
                        if (res.data.msg == "200") {
                            let message = res.data.snackbar;
                            if(message){
                            this.showSnackbar("#b71c1c", res.data.snackbar);
                            }
                            this.chatHistory = res.data.history;
                            this.proctor_avability = res.data.proctor_avability;

                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong...");
                    })
                    .finally(() => {
                        this.content = this.$refs.messagesContainer;
                        this.content.scrollTop = this.content.scrollHeight;
                    });

            },
        },
        mounted() {
            let deviceWidth = window.innerWidth;
           
            this.fetchChat();
            this.chat_div = this.chat_box - 110;
            this.pt = this.chat_div / 2;
            this.chat_data.flag = false;
            this.content = this.$refs.messagesContainer;
            this.content.scrollBottom = this.content.scrollHeight;

             if (deviceWidth > 600) {
            this.chat_box = window.innerHeight - 200;
            this.chat_div = this.chat_box - 110;
            }
             if (deviceWidth < 600) {
            this.chat_box = window.innerHeight - 400;
            this.chat_div = this.chat_box - 110;
          }

//             window.setInterval(() => {
//     this.fetchChat()
//   }, 5000)
        },
    };
</script>

<style scoped>
@-moz-document url-prefix() {
  /* h1 {
    color: red;
  } */
}
.refresh{
    font-size: 15px;
}
    .center {
        text-align: center;
        color: red;
    }
    .first-msg {
        text-align: center;
        padding: 0rem 3rem 0rem 3rem;
        color: green;
    }
    .time {
        float: right;
        font-size: 10px;
        padding-right: 0.7rem;
        color: gray;
    }
    .sender-name {
        padding: 0rem 0.7rem 0rem 0.7rem;
        background: #09809c85;
        color: white;
        font-size: 10px;
    }
    .chat-div {
        overflow: scroll;
        overflow-x: hidden;
        /* background-color:#deeff5; */
    }
    .chat-div::-webkit-scrollbar {
        display: none;
    }
    .grid-s {
        display: grid;
        justify-content: start;
        width: 80%;
        float: left;
    }
    .grid-e {
        display: grid;
        justify-content: end;
        width: 80%;
        float: right;
    }
    .stud-msg-text {
        padding: 0.2rem 0.7rem 0.2rem 0.7rem;
        font-weight: 500;
        font-family: cursive;
        font-size: 16px;
    }
    /* .stud-msg{
    display: flex;
    justify-content: flex-end;
    background: #deeff5;
    border-radius: 5px;
    float: right;
} */
    #stud-chat-btn {
        float: right;
        background-color: #deeff5;
        /* background-color:white; */
        border-radius: 4px;
        position: relative;
        margin-bottom: 1rem;
        width: fit-content;
        justify-content: end;
        height: fit-content;
    }
    #stud-chat-btn:after {
        content: "";
        display: block;
        position: absolute;
        width: 0;
        height: 0;
        right: 5px;
        bottom: -10px;
        border-left: 10px solid transparent;
        border-right: 1px solid transparent;
        border-top: 10px solid#deeff5;
    }

    #p-chat-btn {
        float: right;
        background-color: #deeff5;
        /* background-color:white; */
        border-radius: 4px;
        position: relative;
        margin-bottom: 1rem;
        width: fit-content;
        justify-content: end;
        height: fit-content;
    }
    #p-chat-btn:after {
        content: "";
        display: block;
        position: absolute;
        width: 0;
        height: 0;
        left: 5px;
        bottom: -10px;
        border-right: 10px solid transparent;
        border-left: 1px solid transparent;
        border-top: 10px solid#deeff5;
    }
    .msg {
        padding: 0rem 1rem 0rem 1rem;
        bottom: 0;
        /* position: fixed; */
        width: inherit;
    }
    .chat-icon {
        bottom: 0px;
        right: 0px;
        position: fixed !important;
        font-size: 100px;
        z-index: 1;
        cursor: pointer;
    }
    .main {
        border: 2px solid hsla(190, 99%, 30%, 1);
        border-radius: 5px;
    }
    /* .show {
        background-color: red;
    }
    .slide-enter-active,
    .slide-leave-active {
        transition: all 0.6s ease;
    }
    .slide-enter,
    .slide-leave-to {
        transform: translateY(-100%);
        opacity: 0;
    } */
    .chat-box {
        /* display: grid; */
        height: -webkit-fill-available !important;
        height: auto;
        padding: 3.5rem 0.6rem 0.3rem 0.6rem;
        width: 22rem;
        /* height: 10rem; */
        background: white;
        /* justify-content: end; */
    }
    .chat-box2 {
        width: 22rem;
        /* height: 15rem;
    background: lightgrey; */
    }
    .icon {
        font-size: 25px;
        padding-top: 0.5rem;
        color: white;
        margin-right: 13rem;
    }
    .main-h {
        display: flex;
        /* justify-content: space-between; */
        padding: 0rem 1rem 0rem 1rem;
        position: fixed;
        /* top: 0; */
        width: 100%;
        z-index: 1;
        height: 3.5rem;
        background: linear-gradient(130deg, hsla(190, 99%, 30%, 1) 0%, hsla(226, 50%, 65%, 1) 180%);
    }

    .main-h1 {
        display: flex;
        /* justify-content: space-between; */
        padding: 0rem 1rem 0rem 1rem;
        position: fixed;
        bottom: 0;
        width: 100%;
        z-index: 1;
        height: 3.5rem;
        background: linear-gradient(130deg, hsla(190, 99%, 30%, 1) 0%, hsla(226, 50%, 65%, 1) 180%) !important;
    }

      @media only screen and (max-width: 600px) {
      }
</style>
